import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, FormBuilder, NgForm, FormGroupDirective, FormArray } from '@angular/forms';
import { FormValidatorService } from '../../shared/form_Validation/form-validator.service';
import { ApiService } from '../../services/api.service';
import { CookieService } from 'ngx-cookie-service';
import { ReCaptchaComponent } from '../shared/popups/re-captcha/re-captcha.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-createaccount',
  templateUrl: './createaccount.component.html',
  styleUrls: ['./createaccount.component.css']
})
export class CreateaccountComponent implements OnInit {
  email: FormGroup;
  googleToken = '';
  year = new Date().getFullYear();
  constructor(private route: ActivatedRoute
    , private router: Router
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private Register: ApiService
    , private cookieService: CookieService
    , public dialog: MatDialog) { }

  ngOnInit() {
    sessionStorage.removeItem('token');
    this.email = this.formBuilder.group({
      Email: new FormControl('', [Validators.required, Validators.email]),
    });
    this.route.queryParamMap.subscribe(paramsdata => {
      const token = paramsdata['params']['token'];
      if (token) {
        this.cookieService.set('token', token, 0, '/',
          null,
          null, 'Lax');
          this.checkValidity();
      } else {
         this.router.navigate(['/']);
        this.cookieService.deleteAll('/');
      }
    });
  }
  checkValidity(){
    this.Register.functionGET('invite/authenticate').subscribe((res) => {});
  }
  SetCookie() {
    sessionStorage.setItem('Email', this.email.get('Email').value);
    const registration_email = sessionStorage.getItem('Email');

    if (this.email.valid) {
      this.CheckEmail();
    } else {
      this.Formvalidator.markFormGroupTouched(this.email);
    }
  }
  CheckEmail() {
    const data = {
      user_email: this.email.get('Email').value,
      captchaToken: this.googleToken
    };
    this.Register.functionPOST('user/checkEmail', data).subscribe((res) => {


      this.router.navigate(['/register/user-business']);
    },
      err => {
        
        let msg = err['error'];
        if(err['error']['message']){
          msg = err['error']['message'];
        }
        if (err['error']['isCaptchaRequired']) {
          this.openCaptcha();
        }
        this.Register.openSnackBar(msg, 'Error');

      });
  }

  openCaptcha(): void {
    const data = { title: 'Forgot Password', type: 'forgot_password' };
    const dialogRef = this.dialog.open(ReCaptchaComponent, {
      data, width: '400px',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.googleToken = result;
        // this.Login();
      }
    });
  }


  goToLogin(){
     this.cookieService.deleteAll('/');
    this.router.navigate(['/']);

  }
}
